export function getFullName(contact: any) {
	return `${contact?.company_name ? `${contact?.company_name}` : ``} ${contact?.firstname} ${contact?.lastname}`;
}